module.exports = __webpack_public_path__ + "static/git-343dde03015de26bb0cfa2f9fa85ebd1.jpg";